module.exports = __webpack_public_path__ + "static/11-274adde4e367fb6df2e6ddda5a100211.jpg";